import { Loader, Application, Sprite, Texture, Graphics, Container } from 'pixi.js';
import { gsap } from 'gsap';

class HeroFieldNotes {
    constructor(el) {
        this.el = el;
        this.width = 776;
        this.height = 670;
        this.init();
    }

    init() {
        this.app = new Application({
            width: this.width,
            height: this.height,
            backgroundColor: 0x000000,
            backgroundAlpha: 0,
            resolution: 2,
            autoResize:true,
            antialias: true,
            autoDensity: true,
        });

        this.el.appendChild(this.app.view);
        this.initAssets();
        this.loadImages();
    }

    initAssets() {
        this.assets = {
            imgFace : {
                url: `${window.assets_url}/images/field-notes/img-face.png`,
                x: 736,
                y: 396,
                float: true,
            },
            imgPad : {
                url: `${window.assets_url}/images/field-notes/img-pad.png`,
                x: 660,
                y: 137,
                chaos: true,
            },
            imgPhone : {
                url: `${window.assets_url}/images/field-notes/img-phone.png`,
                x: 114,
                y: 457,
                chaos: true,
            },
            imgPods : {
                url: `${window.assets_url}/images/field-notes/img-pods.png`,
                x: 186,
                y: 113,
                chaos: true,
            },
            imgProcessor : {
                url: `${window.assets_url}/images/field-notes/img-processor.png`,
                x: 660,
                y: 566,
                float: true,
            }
        }

        this.circles = {
            circleCenter: {
                r: 294,
                x: 411,
                y: 324,
                fill: '0x6f3eaa'
            },
            circleLeftTop: {
                r: 78,
                x: 188,
                y: 102,
                fill: '0xf1c400',
                float: true,
            },
            circleLeftBottom: {
                r: 70,
                x: 117,
                y: 457,
                fill: '0xed8c00',
                float: true,
            },
            circleRightTop: {
                r: 69,
                x: 661,
                y: 136,
                fill: '0x00a4b1',
                float: true,
            },
            small1: {
                r: 15,
                x: 754,
                y: 284,
                fill: '0x6f3eaa',
                float: true,
            },
            small2: {
                r: 7,
                x: 723,
                y: 200,
                fill: '0x6f3eaa',
                float: true,
            },
            small3: {
                r: 7,
                x: 107,
                y: 51,
                fill: '0xf1c400',
                float: true,
            },
            small4: {
                r: 4,
                x: 94,
                y: 84,
                fill: '0xf1c400',
                float: true,
            },
            small5: {
                r: 2,
                x: 95,
                y: 110,
                fill: '0xf1c400',
                float: true,
            },
            small6: {
                r: 16,
                x: 91,
                y: 204,
                fill: '0x6f3eaa',
                float: true,
            },
            small7: {
                r: 10,
                x: 71,
                y: 281,
                fill: '0x6f3eaa',
                float: true,
            },
            small8: {
                r: 4,
                x: 82,
                y: 342,
                fill: '0x6f3eaa',
                float: true,
            },
        }
    }

    loadImages() {
        this.loader = new Loader();

        this.loader.add('title', `${window.assets_url}/images/field-notes/img-title.svg`);

        for (const key in this.assets) {
            this.loader.add(this.assets[key].url);
        }

        this.loader.load((loader, resources) => {
            this.onImagesLoaded();
        });
    }

    onImagesLoaded() {
        this.title = new Sprite(this.loader.resources['title'].texture);
        this.title.originalWidth = this.title.width;
        this.title.originalHeight = this.title.height;

        // add circles to stage
        for (const key in this.circles) {
            const circle = this.circles[key];
            const graphics = new Graphics();
            graphics.beginFill(circle.fill);
            graphics.drawCircle(0, 0, circle.r);
            graphics.endFill();
            const container = new Container();
            container.x = circle.x;
            container.y = circle.y;
            container.scale.set(0.1);
            container.addChild(graphics);
            graphics.alpha = 0;
            this.app.stage.addChild(container);
            this.circles[key].graphics = graphics;
            this.circles[key].container = container;
        }

        // add images to stage (images are retina)
        for (const key in this.assets) {
            const asset = this.assets[key];
            const texture = Texture.from(asset.url);
            const sprite = new Sprite(texture);
            sprite.x = asset.x;
            sprite.y = asset.y;
            sprite.width = texture.orig.width;
            sprite.height = texture.orig.height;
            sprite.anchor.set(0.5);
            sprite.alpha = 0;
            sprite.scale.set(0.1);
            this.app.stage.addChild(sprite);
            this.assets[key].sprite = sprite;
        }

        this.title.x = 413;
        this.title.y = 316;
        this.title.anchor.set(0.5);
        this.title.scale.set(0.1);
        this.title.alpha = 0;

        this.app.stage.addChild(this.title);



        this.appearAnimation();
        this.generalAnimation();
    }

    appearAnimation() {
        this.timeline = gsap.timeline();

        const circlesArray = Object.values(this.circles);

        for (let i = 0; i < circlesArray.length; i++) {
            const circle = circlesArray[i];

            this.timeline.to(circle.container.scale, {
                duration: 1,
                x: 1,
                y: 1,
                ease: "back.out(1.7)",
                onStart: () => {
                    circle.graphics.alpha = 1;
                }
            }, (i * 0.15));
        }

        const assetsArray = Object.values(this.assets);

        for (let i = 0; i < assetsArray.length; i++) {
            const asset = assetsArray[i];

            this.timeline.to(asset.sprite.scale, {
                duration: 1,
                x: .5,
                y: .5,
                ease: "back.out(1.7)",
                onStart: () => {
                    asset.sprite.alpha = 1;
                }
            }, (i * 0.15) + 0.3);
        }

        this.timeline.to(this.title.scale, {
            duration: 1,
            x: .5,
            y: .5,
            ease: "back.out(1.7)",
            onStart: () => {
                this.title.alpha = 1;
            }
        }, 0.5);
    }

    generalAnimation() {
        for (const key in this.assets) {
            const asset = this.assets[key];
            if (typeof asset.chaos !== 'undefined' && asset.chaos) {
                const sprite = asset.sprite;

                const animateChaotically = () => {
                    const rotation = (Math.random() * 16 - 8) * (Math.PI / 180);
                    const x = asset.x + (Math.random() * 6 - 3);
                    const y = asset.y + (Math.random() * 6 - 3);

                    gsap.to(sprite, {
                        duration: 0.75,
                        rotation: rotation,
                        x: x,
                        y: y,
                        ease: "none",
                        onComplete: () => {
                            gsap.delayedCall(0.2, animateChaotically);
                        },
                    });
                };

                animateChaotically();
            } else if (typeof asset.float !== 'undefined' && asset.float) {
                const sprite = asset.sprite;
                let radius = 5;
                let angle = 0;
                const rotationDirection = Math.random() > 0.5 ? 1 : -1;

                const initialX = asset.x + radius * Math.cos(angle);
                const initialY = asset.y + radius * Math.sin(angle);

                gsap.to(sprite, {
                    x: initialX,
                    y: initialY,
                    duration: 0.5,
                    ease: "sine.inOut",
                    onComplete: animateRadialFloatingAsset,
                });

                function animateRadialFloatingAsset() {
                    angle += rotationDirection * 0.05;

                    const x = asset.x + radius * Math.cos(angle);
                    const y = asset.y + radius * Math.sin(angle);

                    gsap.to(sprite, {
                        duration: 0.05,
                        x: x,
                        y: y,
                        ease: "linear",
                        onComplete: animateRadialFloatingAsset,
                    });

                    radius += Math.sin(angle) * 0.1;
                }
            }
        }

        for (const key in this.circles) {
            const circle = this.circles[key];
            if (typeof circle.float !== 'undefined' && circle.float) {
                const container = circle.container;
                let radius = 5;
                let angle = 0;
                const rotationDirection = Math.random() > 0.5 ? 1 : -1;

                const initialX = circle.x + radius * Math.cos(angle);
                const initialY = circle.y + radius * Math.sin(angle);

                gsap.to(container, {
                    x: initialX,
                    y: initialY,
                    duration: 0.5,
                    ease: "sine.inOut",
                    onComplete: animateRadialFloating,
                });

                function animateRadialFloating() {
                    angle += rotationDirection * 0.05;

                    const x = circle.x + radius * Math.cos(angle);
                    const y = circle.y + radius * Math.sin(angle);

                    gsap.to(container, {
                        duration: 0.05,
                        x: x,
                        y: y,
                        ease: "linear",
                        onComplete: animateRadialFloating,
                    });

                    radius += Math.sin(angle) * 0.1;
                }
            }
        }
    }
}

export default HeroFieldNotes
